import { atom } from "jotai";
import type { PilotRights } from "web_myplann/Utils/WebViewModel";

export const rightsState = atom<PilotRights | undefined>(undefined);
